module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-20.f231f665.jpg";